import React from 'react';
import { Link } from 'react-router-dom';
import { getLocaleObjContent, getLocaleWordContent } from '../../../../../utils/language.util';

function SignUpAccept({ terms, onChangeInput }) {
    return (
        <div className="login_inputbox">
            <div className="col-md-12 col-sm-12 col-xs-12">
                <label className="accept-check">
                    <input type="checkbox" name="validation.terms" checked={terms} />
                    <span style={{ color: '#333' }}>{getLocaleWordContent('전체동의')} </span>
                </label>
                <div className="lst_terms">
                    <div className="term">
                        <Link to="/terms" className="red"> <p className="txt">{getLocaleWordContent('이용약관')}</p> </Link>
                        <p>
                            <Link to="/terms" className="red">
                                <img src={require('@/resources/assets/images/arrow_r.png')} alt="next" />
                            </Link>
                        </p>
                    </div>
                    <div className="term">
                        <Link to="/terms" className="red"> <p className="txt">{getLocaleWordContent('개인정보정책')}</p> </Link>
                        <p>
                            <Link to="/terms" className="red">
                                <img src={require('@/resources/assets/images/arrow_r.png')} alt="next" />
                            </Link>
                        </p>
                    </div>

                </div>

            </div>
        </div>
    );
}

export default SignUpAccept;
